import TextInput from './TextInput';

export { type TextInputProps } from './TextInput';
export default TextInput;
